export default {"src":"/login-app/[GIT_HASH]/_next/static/media/not.d0ac1252.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};